export default __webpack_public_path__ + "static/media/cross-orange.a5b67f50.svg";